import React from 'react';
import { cn } from '@/lib/utils';

/**
 * Centralized Price component for GPGT.
 * Displays the AED currency icon and formatted amount.
 */
const Price = ({ amount, className, iconClassName, showIcon = true, size = 'md' }) => {
  const formattedAmount = typeof amount === 'number' ? amount.toFixed(2) : '0.00';

  const sizeClasses = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
    '2xl': 'text-2xl',
    '3xl': 'text-3xl',
    '4xl': 'text-4xl',
  };

  return (
    <span className={cn("whitespace-nowrap inline-flex items-center font-bold", sizeClasses[size] || sizeClasses.md, className)}>
      {showIcon && (
        <svg 
          viewBox="0 0 24 24" 
          fill="currentColor" 
          xmlns="http://www.w3.org/2000/svg" 
          className={cn("mr-1 flex-shrink-0", size === 'xs' || size === 'sm' ? "w-[1em] h-[1em]" : "w-[1.15em] h-[1.15em]", iconClassName)}
        >
          <path d="M3 3h7.5C13.8 3 17 6.2 17 9.5S13.8 16 10.5 16H3V3zm2.5 2.5V13.5H10.5c1.93 0 4-1.57 4-4S12.43 5.5 10.5 5.5H5.5z"/>
          <rect x="1" y="8" width="16" height="1.8" rx="0.5"/>
          <rect x="1" y="11.5" width="16" height="1.8" rx="0.5"/>
        </svg>
      )}
      {formattedAmount}
    </span>
  );
};

export default Price;
